import {Card, FormControl} from 'platform/components';
import {VStack} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import {GetArticleResponse, GetWarehouseResponse, GetWarehousesResponse} from '@dms/api/warehouse';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {ArticleDetailForm} from '../types/ArticleDetailFormSchema';
import {GeneralInformationTabBasicInformationForm} from './GeneralInformationTabBasicInformationForm';
import {GeneralInformationTabUnitsForm} from './GeneralInformationTabUnitsForm';

interface OverviewGeneralInformationTabProps extends TestIdProps {
  articleId: string;
  article: GetArticleResponse;
  control: FormControl<ArticleDetailForm>;
  formApi: UseFormReturn<ArticleDetailForm>;
  manufacturerId: string;
  warehouse: GetWarehouseResponse;
  warehouses: GetWarehousesResponse;
  leafId: string | Nullish;
  leafIdChange: (leafId: string | Nullish) => void;
  isNameDisabled: boolean;
  isCategoryDisabled: boolean;
  isPricingDisabled: boolean;
}

export function GeneralInformationTab(props: OverviewGeneralInformationTabProps) {
  return (
    <Card>
      <VStack data-testid={suffixTestId('articleCatalogs', props)} width="100%">
        <GeneralInformationTabBasicInformationForm
          articleId={props.articleId}
          control={props.control}
          formApi={props.formApi}
          warehouseId={props.article.warehouseId}
          manufacturerId={props.manufacturerId}
          warehouseNumber={props.warehouse.warehouseNumber}
          warehouses={props.warehouses}
          supplierId={props.article.supplierId}
          storageLocation={props.article.storageLocation}
          authorizationProfileId={props.warehouse.authorizationProfileId}
          isRemovable={props.article.isRemovable}
          leafId={props.leafId}
          leafIdChange={props.leafIdChange}
          isNameDisabled={props.isNameDisabled}
          isCategoryDisabled={props.isCategoryDisabled}
          isPricingDisabled={props.isPricingDisabled}
        />
        <GeneralInformationTabUnitsForm
          formApi={props.formApi}
          control={props.control}
          article={props.article}
          data-testid={suffixTestId('units', props)}
        />
      </VStack>
    </Card>
  );
}
